import { useEffect, useState } from "react";
import "./InativarFabricanteEstaleiroModal.css";

export default function InativarFabricanteEstaleiroModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao inativar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fbein-bg" onClick={onClose}>
      <div className="fbein-box" role="dialog" aria-modal="true" aria-label="Inativar fabricante" onClick={(e) => e.stopPropagation()}>
        <header className="fbein-head">
          <h3 className="fbein-title">Inativar</h3>
          <button className="fbein-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="fbein-body">
          Deseja <strong>inativar</strong> "{titulo || "este registro"}"?
          {err ? <div className="fbein-err">{err}</div> : null}
        </div>
        <footer className="fbein-foot">
          <button className="fbein-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="fbein-btn fbein-btn-warn" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Inativando..." : "Inativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}

